import type { AdminRole } from '@/lib/api-admin';

/**
 * 주문 기본설정 RBAC. be-order-lifecycle 계약: `@PreAuthorize` 가 SUPER_ADMIN /
 * OPS_ADMIN 만 허용한다. read·write 동일 게이트(설정 페이지 전체가 운영 권한).
 */
export const ORDER_POLICY_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN'];
